// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__bhkKM","log":"ModalInventoryLogs_log__1KdIh","date":"ModalInventoryLogs_date__6lkDR","userName":"ModalInventoryLogs_userName__148Yo"};